var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF_File",
    "data-name": "PDF File",
    transform: "translate(10756 3822)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 42,
    height: 42,
    transform: "translate(-10756 -3822)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "pdf_1_",
    "data-name": "pdf (1)",
    transform: "translate(-10754.5 -3818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    "data-name": "Path 3237",
    d: "M25.009,0H7.388C6.9,0,6.5.4,6.5,1.169V33.393A.914.914,0,0,0,7.388,34H31.719a.914.914,0,0,0,.888-.607V7.879c0-.423-.056-.559-.156-.659L25.386.156A.537.537,0,0,0,25.009,0Z",
    transform: "translate(0 0)",
    fill: "#e9e9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    "data-name": "Path 3238",
    d: "M37.5.151V7.345h7.194Z",
    transform: "translate(-12.179 -0.059)",
    fill: "#d9d7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    "data-name": "Path 3239",
    d: "M18.691,22.946h0a.975.975,0,0,1-.587-.2,1.455,1.455,0,0,1-.677-1.361c.111-.988,1.333-2.023,3.634-3.077a40.755,40.755,0,0,0,2.3-6.527c-.606-1.319-1.195-3.03-.766-4.033a1.165,1.165,0,0,1,.689-.738,2.981,2.981,0,0,1,.617-.1c.306,0,.575.394.766.637s.585.712-.226,4.13a19.4,19.4,0,0,0,3.089,4.591,11.812,11.812,0,0,1,2.039-.217c.951,0,1.527.222,1.762.678a1.229,1.229,0,0,1-.237,1.311,1.614,1.614,0,0,1-1.348.723,4.036,4.036,0,0,1-2.557-1.387,29.091,29.091,0,0,0-5.36,1.713,17.227,17.227,0,0,1-1.447,2.581C19.759,22.539,19.222,22.946,18.691,22.946Zm1.616-3.112c-1.3.729-1.826,1.328-1.865,1.666-.006.056-.022.2.262.42C18.794,21.892,19.323,21.651,20.307,19.834Zm8.28-2.7c.495.381.616.573.939.573a.915.915,0,0,0,.735-.268.961.961,0,0,0,.14-.252c-.075-.039-.174-.12-.713-.12A8.877,8.877,0,0,0,28.586,17.137Zm-4.535-4a43.285,43.285,0,0,1-1.623,4.592,30.336,30.336,0,0,1,3.944-1.226A20.783,20.783,0,0,1,24.051,13.141ZM23.683,8a1.456,1.456,0,0,0,.058,1.953C24.317,8.672,23.709,7.995,23.683,8Z",
    transform: "translate(-4.289 -2.714)",
    fill: "#cc4b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    "data-name": "Path 3240",
    d: "M31.719,49.321H7.388a.888.888,0,0,1-.888-.888V39H32.607v9.433A.888.888,0,0,1,31.719,49.321Z",
    transform: "translate(0 -15.321)",
    fill: "#cc4b4c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(12.112 26.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    "data-name": "Path 3241",
    d: "M16.74,49.042h-1V42.924H17.5a2.47,2.47,0,0,1,.772.124,2.1,2.1,0,0,1,.685.373,1.95,1.95,0,0,1,.49.6,1.667,1.667,0,0,1,.187.793,2.169,2.169,0,0,1-.158.843,1.761,1.761,0,0,1-.44.635,1.983,1.983,0,0,1-.681.4,2.619,2.619,0,0,1-.88.141H16.74v2.208Zm0-5.362V46.1h.913a1.085,1.085,0,0,0,.361-.063.91.91,0,0,0,.328-.2.994.994,0,0,0,.24-.394,1.867,1.867,0,0,0,.091-.627,1.7,1.7,0,0,0-.041-.344.994.994,0,0,0-.17-.373,1.006,1.006,0,0,0-.361-.3,1.342,1.342,0,0,0-.614-.12H16.74Z",
    transform: "translate(-15.744 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    "data-name": "Path 3242",
    d: "M29.023,45.813a4.494,4.494,0,0,1-.162,1.291,3.209,3.209,0,0,1-.411.9,2.111,2.111,0,0,1-.56.569,2.811,2.811,0,0,1-.6.311,2.486,2.486,0,0,1-.531.133,3.538,3.538,0,0,1-.357.028H24.084V42.924h1.843a3.5,3.5,0,0,1,1.357.245,2.817,2.817,0,0,1,.971.651,2.674,2.674,0,0,1,.577.925A3.064,3.064,0,0,1,29.023,45.813Zm-2.955,2.5a1.649,1.649,0,0,0,1.461-.647,3.286,3.286,0,0,0,.448-1.876,3.178,3.178,0,0,0-.091-.755,1.616,1.616,0,0,0-.353-.676,1.862,1.862,0,0,0-.71-.49,3.056,3.056,0,0,0-1.162-.187H25.08v4.632h.988Z",
    transform: "translate(-19.02 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    "data-name": "Path 3243",
    d: "M35.611,43.679v1.926h2.557v.681H35.611v2.756H34.6V42.924h3.826v.755Z",
    transform: "translate(-23.151 -42.924)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.6e6ca9a234e599a59c652a5193d8cf15.svg";
export { ForwardRef as ReactComponent };